// Regras puras da lista de tarefas (/todolist).
// Mockup: "Tarefas (/todolist · lista pessoal, salva no navegador)".
//
// A lista vive no localStorage do navegador — não há backend. Por isso as
// regras aqui tratam o armazenamento como não confiável: pode vir vazio,
// corrompido ou no formato antigo.
export const CHAVE = "tasks";

/**
 * Formato antigo gravado pela tela anterior: array de strings ou de objetos
 * `{ text }` sem `done`/`createdAt`. Migra sem perder nada.
 */
export const normalizaTarefa = (bruta, indice = 0) => {
  if (typeof bruta === "string") {
    return { id: `${Date.now()}-${indice}`, text: bruta, done: false, createdAt: null };
  }
  if (!bruta || typeof bruta !== "object") return null;
  const text = typeof bruta.text === "string" ? bruta.text : "";
  if (!text.trim()) return null;
  return {
    id: bruta.id || `${Date.now()}-${indice}`,
    text,
    done: Boolean(bruta.done),
    createdAt: bruta.createdAt || null,
  };
};

export const leTarefas = (raw) => {
  if (!raw) return [];
  let dados;
  try {
    dados = JSON.parse(raw);
  } catch (err) {
    // localStorage corrompido não pode derrubar a tela.
    return [];
  }
  if (!Array.isArray(dados)) return [];
  return dados.map(normalizaTarefa).filter(Boolean);
};

/**
 * Pendentes primeiro, cada grupo da mais recente para a mais antiga.
 * Tarefa concluída desce mas não some — o mockup a mostra riscada.
 */
export const ordenaTarefas = (tarefas = []) =>
  [...tarefas].sort((a, b) => {
    if (a.done !== b.done) return a.done ? 1 : -1;
    const da = new Date(a.createdAt || 0).getTime();
    const db = new Date(b.createdAt || 0).getTime();
    return db - da;
  });

export const contaPendentes = (tarefas = []) =>
  tarefas.filter((t) => !t.done).length;

export const criaTarefa = (texto) => {
  const text = String(texto || "").trim();
  if (!text) return null;
  return {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    text,
    done: false,
    createdAt: new Date().toISOString(),
  };
};
